/**
 * 일지 페이지 모듈 (data-page-name="Diary" → loadPageModule 이 인스턴스화 → $j.p).
 *
 * ── 왜 클래스가 얇은가 ──
 * 일지 로직은 레거시 public/js/m-diary.js(함수 165개) / m-diary-a.js 를 babel AST 코드모드로
 * 통째 이관한 Diary/Main.js·Diary/Calendar.js 에 들어있고, 그 함수들은 window.* 전역으로 등록된다
 * (PHP 인라인 onclick·iframe parent.* 가 bare 로 호출하므로). 즉 실제 UI 로직은 그 전역들이 담당하고,
 * 이 페이지모듈 클래스는 진입 훅(page_init)만 갖는 얇은 껍데기다. (점진 이관 중간 상태 — diary-js-migration.md §3)
 *
 * ── Main/Calendar 전역 등록을 왜 여기 top-level(모듈 평가 시)에서 하는가 ──
 * 이 파일은 Pages/Mobile/** glob 로 m.js 엔트리라, 그 top-level 코드는 페이지 렌더(document.ready)
 * '이전'에(=m.js 동기 로드 시점) 평가된다. 반면 페이지모듈의 initialize() 는 ready 시점 async 로드
 * 뒤라 늦다. day.blade 인라인 스크립트가 ready 에 $j.F.DiaryList.renderDay 를 즉시 쓰므로,
 * Main/Calendar 등록은 반드시 eager(여기 top-level)로 해야 레이스가 없다.
 * (ListRenderer 는 UMD 자가등록[$j.F.DiaryList]이라 자기 엔트리 평가 시 스스로 등록 — 별도 처리 불필요.)
 *
 * 순서: Calendar 먼저, Main 마지막 — 두 파일이 동일명 window 함수를 중복정의하므로
 * (구 m-diary.js 가 나중 로드) Main 버전이 window 에서 이기도록. (구 app.js 원본 주석과 동일)
 */
import Calendar from './Diary/Calendar';
import Main from './Diary/Main';
import ProgressBar from './Diary/ProgressBar';

// 일지 페이지 스크립트 전역 등록 (eager — 모듈 평가 시점, ready 이전). 구 Diary/register.js 흡수.
(function registerDiaryGlobals() {
    const reg = (holder, key, ModuleClass, path) => {
        const inst = new ModuleClass();
        Object.defineProperty(inst, '__j_path', { value: path, enumerable: false, configurable: false });
        holder[key] = inst;
    };
    window.$j = window.$j || {};
    window.$j.F = window.$j.F || {};
    window.$j.F.Diary = window.$j.F.Diary || {};
    // ProgressBar 먼저 — 진행바 전역(check_Process_fallow 등)을 Main 의 page_init 보다 앞서 등록.
    reg(window.$j.F.Diary, 'ProgressBar', ProgressBar, 'Pages/Mobile/Diary/ProgressBar');
    reg(window.$j.F.Diary, 'Calendar', Calendar, 'Pages/Mobile/Diary/Calendar');
    reg(window.$j.F.Diary, 'Main', Main, 'Pages/Mobile/Diary/Main');
})();

export default class Diary {
    constructor() {
    }
    initialize() {
        page_init(); // Diary/Main.js 가 window 로 등록한 진입점 (EventBus 구독자 배선)

        // 일지등록 FAB — 오른쪽으로 밀어 숨기기(화면캡쳐 방해 방지). 발주페이지 AI 버튼과 동일 동작.
        // 레거시(Calendar.js)가 탭 전환마다 display 를 켜고 끄지만 FabHide 는 display 를 건드리지 않는다.
        $j.Ui.FabHide.attach('.dia-fab', { key: 'diary_reg', tint: '#7FBB00' });
    }

    /**
     * 모달에서 선택한 값을 해당컬럼에 출력한다.
     * @param id
     */
    print = (id) => {
    }
    /**
     * 적용하기
     */
    apply = (t) => {
    }

}
